import { GetFormattedNumberStringParams, IBigNumber } from "@multiweb/types/multiweb";

/** Parametry formátovacích funkcí */
export type FormatProviderParams = GetFormattedNumberStringParams & {
    culture?: string;
};

/** Vstupní hodnota formátovacích funkcí */
export type FormatProviderInputValues = string | IBigNumber | number | null | undefined;
